import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DataManagementCard = ({ onClearData, onExportData }) => {
  const [showClearConfirm, setShowClearConfirm] = useState(false);
  const [showExportSuccess, setShowExportSuccess] = useState(false);

  const handleClearData = () => {
    onClearData();
    setShowClearConfirm(false);
  };

  const handleExportData = () => {
    onExportData();
    setShowExportSuccess(true);
    setTimeout(() => setShowExportSuccess(false), 3000);
  };

  return (
    <div className="space-y-4">
      <div className="p-4 sm:p-5 bg-muted/50 rounded-lg border border-border">
        <div className="flex items-start gap-3 mb-4">
          <Icon name="Database" size={20} color="var(--color-primary)" strokeWidth={2} />
          <div className="flex-1 min-w-0">
            <h3 className="text-base sm:text-lg font-semibold text-foreground mb-1">
              Local Storage
            </h3>
            <p className="text-sm text-muted-foreground">
              All your data is stored locally on your device. No account required.
            </p>
          </div>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Button
            variant="outline"
            size="default"
            iconName="Download"
            iconPosition="left"
            onClick={handleExportData}
            className="w-full"
          >
            Export All Data
          </Button>
          
          <Button
            variant="destructive"
            size="default"
            iconName="Trash2"
            iconPosition="left"
            onClick={() => setShowClearConfirm(true)}
            className="w-full"
          >
            Clear All Data
          </Button>
        </div>
      </div>

      {showExportSuccess && (
        <div className="p-4 bg-success/10 border border-success/20 rounded-lg flex items-center gap-3 animate-in fade-in slide-in-from-top-2 duration-200">
          <Icon name="CheckCircle2" size={20} color="var(--color-success)" strokeWidth={2} />
          <p className="text-sm sm:text-base text-success-foreground">
            Data exported successfully!
          </p>
        </div>
      )}

      {showClearConfirm && (
        <div 
          className="fixed inset-0 bg-background/95 z-[200] flex items-center justify-center p-4"
          role="dialog"
          aria-modal="true"
          aria-labelledby="clear-data-title"
        >
          <div className="w-full max-w-md bg-card rounded-xl shadow-therapeutic-xl p-6 sm:p-8 border border-border">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-error/10">
                <Icon name="AlertTriangle" size={24} color="var(--color-error)" strokeWidth={2} />
              </div>
              <h2 id="clear-data-title" className="text-xl sm:text-2xl font-heading font-bold text-foreground">
                Clear All Data?
              </h2>
            </div>
            
            <p className="text-sm sm:text-base text-muted-foreground mb-6">
              This will permanently delete all your symptom entries, settings, and preferences. This action cannot be undone.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                variant="outline"
                size="lg"
                onClick={() => setShowClearConfirm(false)}
                className="flex-1"
              >
                Cancel
              </Button>
              <Button
                variant="destructive"
                size="lg"
                iconName="Trash2"
                iconPosition="left"
                onClick={handleClearData}
                className="flex-1"
              >
                Clear Data
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataManagementCard;